// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"aa9456087ff56126dfb3","883":"23e5a95b025a16323d03"}[chunkId] + ".js";
};